module.exports = __webpack_public_path__ + "static/together_bg3-9d135351a469a13cd49f1e06068d23d8.png";